type stateType = { showDialog: boolean; marketingCookieAllowed: boolean }

export const namespaced = true

export const state = () => ({
  showDialog: true,
  marketingCookieAllowed: false,
})

export const mutations = {
  setDialogFlag(state: stateType, show: boolean = false) {
    state.showDialog = show
  },
  setMarketingCookieFlag(state: stateType, allow: boolean = false) {
    state.marketingCookieAllowed = allow
  },
}

export const getters = {
  showDialog(state: stateType): boolean {
    return state.showDialog
  },

  areMarketingCookiesAllowed(state: stateType): boolean {
    return state.marketingCookieAllowed
  },
}
